// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_62-0";
export var eligibilityCardNotEligible = "_62-1";